<template>
  <BasePageContainer>
    <div v-if="isParentMember">
      <div class="general-form__group form-group row align-items-center">
        <label
          for="email"
          class="col-4 col-form-label">メールアドレス</label>
        <div class="col-8">
          <b-form-input
            v-model="profile.email"
            type="text"
            :disabled="true"
            hide-header />
        </div>
        <p class="pl-3 pt-2 form-info__notice">
          ※保護者共有アカウントのログインメールアドレスです
        </p>
      </div>
    </div>
    <div
      v-else
      class="mypage__body general-form">
      <validation-observer
        v-slot="observer"
        tag="form">
        <div class="general-form__group form-group row">
          <label
            class="col-4 col-form-label">名前</label>
          <div class="col-8">
            <validation-provider
              v-slot="v"
              name="名前"
              rules="required|max:50">
              <b-form-input
                v-model="profile.name"
                type="text"
                hide-header />
              <p class="text-primary">
                {{ v.errors[0] }}
              </p>
            </validation-provider>
          </div>
        </div>
        <div
          class="general-form__group form-group row align-items-center">
          <label
            for="photo"
            class="col-4 col-form-label">画像登録</label>
          <div
            v-if="avatarImageUrl === null"
            class="col-8 mt-2">
            <img
              src="@/assets/images/unknown.png"
              class="img-fluid rounded-circle general-form__img">
            <div class="general-form__btn-group d-flex mt-2">
              <label
                for="photo"
                class="btn btn-secondary btn--small mr-2">
                <b-form-file
                  placeholder="画像を選択"
                  browse-text="選択"
                  accept="image/*"
                  @input="onInputImage" />
              </label>
            </div>
          </div>
          <div
            v-else
            class="col-8 mt-2">
            <img
              :src="avatarImageUrl"
              class="img-fluid rounded-circle general-form__img">
            <div class="general-form__btn-group d-flex mt-2">
              <p
                class="h2"
                style="position: absolute; top: 0px; left: 100px;"
                @click="onClickImageDelete">
                <b-icon-x-circle-fill />
              </p>
              <label
                for="photo"
                class="btn btn-secondary btn--small mr-2">
                <b-form-file
                  placeholder="画像を選択"
                  browse-text="選択"
                  accept="image/*"
                  @input="onInputImage" />
              </label>
            </div>
          </div>
        </div>
        <div class="general-form__group form-group row">
          <label
            for="title"
            class="col-4 col-form-label">役職</label>
          <div class="col-8">
            <b-form-input
              v-model="profile.position"
              type="text"
              hide-header />
          </div>
        </div>
        <div class="general-form__group form-group row">
          <label
            for="team"
            class="col-4 col-form-label">グループ</label>
          <div class="col-8">
            <b-form-input
              v-if="profile.department"
              v-model="profile.department.name"
              type="text"
              :disabled="true"
              hide-header />
            <b-form-input
              v-else
              type="text"
              :disabled="true"
              hide-header />
          </div>
        </div>
        <template v-if="studentNumberOption">
          <div class="general-form__group form-group row">
            <label class="col-4 col-form-label">学年</label>
            <div class="col-8">
              <b-form-select
                v-model="profile.grade"
                :options="gradeOptions"
                :disabled="true" />
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label class="col-4 col-form-label">組</label>
            <div class="col-8">
              <b-form-select
                v-model="profile.homeroom"
                :options="homeroomOptions"
                :disabled="true" />
            </div>
          </div>
          <div class="general-form__group form-group row">
            <label class="col-4 col-form-label">出席番号</label>
            <div class="col-8">
              <b-form-select
                v-model="profile.attendanceNumber"
                :options="attendanceNumberOptions"
                :disabled="true" />
            </div>
          </div>
        </template>
        <div class="general-form__group form-group row">
          <label
            class="col-4 col-form-label">#タグ</label>
          <div class="col-8">
            <settings-tag-select-menu
              :tag1="profile.tag1 || null"
              :tag2="profile.tag2 || null"
              @save="onSaveTag" />
          </div>
        </div>
        <fieldset class="general-form__group form-group">
          <div class="row">
            <legend class="col-form-label col-4 pt-0">
              モバイルホーム表示
            </legend>
            <div class="col-8">
              <validation-provider
                v-slot="v"
                name="モバイルホーム表示"
                rules="required">
                <b-form-radio-group
                  v-model="profile.homeView">
                  <div class="form-check">
                    <b-form-radio
                      value="goal_list">
                      ノート一覧
                    </b-form-radio>
                    <b-form-radio
                      value="member_list">
                      メンバーリスト
                    </b-form-radio>
                  </div>
                </b-form-radio-group>
                <p class="text-primary">
                  {{ v.errors[0] }}
                </p>
              </validation-provider>
            </div>
          </div>
        </fieldset>
        <div class="general-form__group form-group row">
          <label
            for="email"
            class="col-4 col-form-label">メールアドレス</label>
          <div class="col-8">
            <b-form-input
              v-model="profile.email"
              type="text"
              :disabled="true"
              hide-header />
            <router-link
              to="/settings/email_update/">
              <button
                type="button"
                class="btn btn-secondary btn--small mt-2">
                メールアドレスを変更する
              </button>
            </router-link>
          </div>
        </div>
        <fieldset class="general-form__group form-group">
          <div class="row">
            <legend class="col-form-label col-4 pt-0">
              メール通知
            </legend>
            <div class="col-8">
              <validation-provider
                v-slot="v"
                name="メール通知"
                rules="required">
                <b-form-radio-group
                  v-model="profile.enabledSendEmail">
                  <div class="form-check">
                    <b-form-radio
                      value="true">
                      オン
                    </b-form-radio>
                    <b-form-radio
                      value="false">
                      オフ
                    </b-form-radio>
                  </div>
                </b-form-radio-group>
                <p class="text-primary">
                  {{ v.errors[0] }}
                </p>
              </validation-provider>
              <div class="general-form__notice mt-2">
                <p>※オンにするとあなたへの新着コメントをメールでお知らせいたします。</p>
              </div>
            </div>
          </div>
        </fieldset>
        <div class="general-form__group form-group row">
          <label
            for="inputPassword3"
            class="col-4 col-form-label">パスワード</label>
          <div class="col-8">
            <input
              id="inputPassword3"
              class="form-control"
              type="passward"
              value="****"
              :disabled="true">
            <div class="general-form__notice mt-2">
              <p>※セキュリティのためパスワードは非表示となっております。</p>
            </div>
            <router-link
              to="/settings/password_update/">
              <button
                type="button"
                class="btn btn-secondary btn--small mt-2">
                パスワードを変更する
              </button>
            </router-link>
          </div>
        </div>
        <div class="general-form__group form-group row">
          <label
            for="memo"
            class="col-4 col-form-label">
            メモ
          </label>

          <div class="col-8">
            <b-form-textarea
              id="textarea"
              v-model="profile.memo"
              placeholder="メモ"
              rows="5"
              max-rows="10" />
          </div>
        </div>
        <div class="general-form__group form-group row">
          <label
            class="col-4 col-form-label">フォロー設定
          </label>
          <div class="col">
            <ul
              class="list-unstyled">
              <settings-follow-department-menu
                v-for="department in accessibleDepartments"
                :key="department.id"
                :local-members-following="localMembersFollowing(department.id)"
                :department-is-followed="departmentIsFollowed(department.id)"
                class="mt-2"
                :department="department" />
            </ul>
            <div class="general-form__notice mt-2">
              <p>※フォローしたメンバーの新規活動が通知画面に表示されます。</p>
            </div>
            <div class="mt-3">
              <router-link
                to="/settings/follow">
                <button
                  type="button"
                  class="btn btn-secondary">
                  フォローの追加・編集
                </button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="general-form__btn row mt-5">
          <div class="col-6">
            <button
              type="button"
              class="btn btn-block btn-cancel"
              @click="onClickCancel">
              キャンセル
            </button>
          </div>
          <div class="col-6">
            <button
              type="button"
              class="btn btn-block btn-primary"
              @click="observer.passes(onClickSave)">
              保存
            </button>
          </div>
        </div>
        <div
          v-if="profile.role === 'manager'"
          class="row mt-5">
          <div class="col-4">
            <label class="col-form-label">管理機能</label>
          </div>
          <div class="col-8 mt-2">
            <router-link
              to="/admin/members/">
              <button
                type="button"
                class="btn btn-block btn-secondary">
                ユーザー管理
              </button>
            </router-link>
          </div>
          <div class="col-8 offset-4 mt-2">
            <router-link
              to="/admin/groups/">
              <button
                type="button"
                class="btn btn-block btn-secondary">
                グループ管理
              </button>
            </router-link>
          </div>
        </div>
      </validation-observer>
    </div>

    <div class="general-form__item d-flex form-info justify-content-between mt-6 mb-2">
      <a
        href="#"
        class="form-info__logout"
        data-testid="logout-button"
        @click.prevent="onClickLogout">
        <img
          src="@/assets/images/icon_logout.svg"
          class="img-fluid"
          width="16">
        ログアウト
      </a>
      <div class="form-info__detail text-right">
        <div class="form-info__date">
          <p>アプリ更新日時: {{ loadedAt | dateTime }}</p>
        </div>
      </div>
    </div>
    <div class="text-right mb-6">
      <b-button
        variant="light"
        size="sm"
        class="col-4 offset-8"
        @click="onClickReload">
        アプリ更新
      </b-button>
    </div>
  </BasePageContainer>
</template>

<script>
import loadImage from 'blueimp-load-image'
import { mapState, mapGetters } from 'vuex'
import SettingsFollowDepartmentMenu from '@/components/view/SettingsFollowDepartmentMenu'
import SettingsTagSelectMenu from '@/components/view/SettingsTagSelectMenu'
import { format } from 'date-fns'
import { gradeOptions, homeroomOptions, attendanceNumberOptions } from '@/helper/studentNumber'

export default {
  components: {
    SettingsFollowDepartmentMenu,
    SettingsTagSelectMenu,
  },
  filters: {
    dateTime(v) {
      if (!v) return ''
      return format(v, 'yyyy/M/d HH:mm')
    }
  },
  data() {
    return {
      profile: {},
      // avatarのFile
      avatarFile: null,
      // avatarのURLまたはbase64文字列
      avatarImageUrl: null,
      follows: [],
      gradeOptions,
      homeroomOptions,
      attendanceNumberOptions,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState(['loadedAt']),
    ...mapGetters('auth', ['isParentMember']),
    accessibleDepartments() {
      if (!this.user) return []
      return this.user.accessibleDepartments
    },
    departmentsFollowing() {
      if (this.follows.length === 0) return []
      const arr = this.follows.filter(f => !!f.department)
      return arr.map(a => a.department.id)
    },
    ...mapGetters('tenant', ['studentNumberOption']),
  },
  mounted() {
    this.created()
  },
  methods: {
    departmentIsFollowed(departmentId) {
      return !!this.departmentsFollowing.find(d => d === departmentId)
    },
    localMembersFollowing(departmentId) {
      if (this.follows.length === 0) return []
      const arr = this.follows.filter(f => !!f.user && f.user.department === departmentId)      
      return arr.map(a => a.user)
    },
    async fetchFollows() {
      const follows = await this.$axios.get('/follow/')
      this.follows = follows.data.results
    },
    onClickReload() {
      location.reload(true)
    },
    async created() {
      this.$store.commit('startLoading')
      const [tenantInfo, me] = await Promise.all([
        this.$axios.get('/tenants/').then(res => res.data).catch(() => null),
        this.$axios.get('/accounts/me/').catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        }),
        this.fetchFollows().catch(() => {
          this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
        })
      ])
      if (tenantInfo) {
        this.$store.commit('tenant/setTenantInfo', tenantInfo)
      }
      this.profile = me.data
      if (me.data.avatar) {
        this.avatarImageUrl = me.data.avatar
      }
      this.$store.commit('finishLoading')
    }, 
    onClickLogout(){ 
      this.$store.dispatch('auth/logout')
      this.$router.push('/auth/login')
      this.$store.commit('notify/set', {
        message: 'ログアウトしました。'
      })
    },
    onClickSave(){
      this.$store.commit('startLoading')
      const params = {
        name: this.profile.name,
        position: this.profile.position,
        homeView: this.profile.homeView,
        enabledSendEmail: this.profile.enabledSendEmail,
        memo: this.profile.memo
      }

      // 顔写真は変化がないのであれば変更しない
      if (this.avatarImageUrl !== this.profile.avatar) {
        params.avatar = this.avatarImageUrl
      }

      this.$axios.patch('/accounts/me/', params).then(() => {
        this.$store.commit('notify/set', {message: '保存しました。'})
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      }).finally(() => {
        this.created()
        this.$axios.get('/accounts/me/').then(res=>{
          this.$store.commit('auth/setUser', res.data)
        })
        
        this.$store.commit('finishLoading')
      })

    },
    onSaveTag({ tag1, tag2 }) {
      this.$store.commit('startLoading')
      this.$axios.patch('/accounts/me/', { tag1, tag2 }).then(() => {
        this.$set(this.profile, 'tag1', tag1)
        this.$set(this.profile, 'tag2', tag2)
        this.$store.commit('notify/set', { message: 'タグを保存しました。' })
      }).catch((e) => {
        console.error(e)
        this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    },
    onClickCancel(){
      this.created()
    },
    onClickImageDelete() {
      this.avatarFile = null
      this.avatarImageUrl = null
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    onInputImage(file) {
      if (!file) return

      loadImage.parseMetaData(file, data => {
        const options = {
          maxWidth: 256,
          maxHeight: 256,
          canvas: true // canvas にリサイズ後の写真を書出す為必要
        }
        if (data.exif) {
          options.orientation = data.exif.get('Orientation')
        }
        loadImage(
          file,
          (canvas) => {
            this.avatarImageUrl = canvas.toDataURL('image/png')
          },
          options
        )
      })
    },
  }

}
</script>

<style lang="scss" scoped>
.mypage{
  &__head{
    background-color: $primary;
    color: $white;
    border-radius: 8px;
  }
  &__img{
    object-fit: cover; 
    width: 60px;
    height: 60px;
    max-width: 60px;
    
  }
  &__name{
    font-weight: bold;
  }
  &__title{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
  &__team{
    font-size: $fs-s;
    line-height: 150%;
    font-weight: bold;
  }
}

.form-info{
  color: $grey09;
  &__logout{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__reload{
    text-decoration: none;
    font-weight: bold;
    color: $grey09;
    font-size: $fs-m;
  }
  &__date{
    font-size: $fs-m;
  }
  &__notice{
    font-size: $fs-s;
  }
}
</style>